import './schema.js';
import './aframe-helpers.js';
import './color-utils.js';
import './format-utils.js';
import './animation.js';
import './data-utils.js';
import './bar-rendering-utils.js';
import './bar-updates.js';
import './ui-utils.js';
import './tick-utils.js';
import './timeline-utils.js';
import './position-utils.js';
import './emissive-utils.js';
import './data-loading.js';
import './init-lifecycle.js';
import './bar-rendering.js';
import './bar-updates-main.js';
